// 表单数据
export const formData = {
    opinion: ''
}

// 表单验证规则
export const formRules = {
    opinion: [{ required: true, message: "审批意见不能为空", trigger: "blur" }]
}